import tmhRequest from '@/config/tmhRequest'

export default {
    searchCustomerShip: function (data) {
        return tmhRequest({
            url: '/customer/tmh/customership/searchcustomership',
            method: 'post',
            params: data,
        })
    },
    searchListCustomerShip: function (data) {
        return tmhRequest({
            url: '/customer/tmh/customership/searchlistcustomership',
            method: 'post',
            params: data,
        })
    },
    searchLimitByPage: function (data) {
        return tmhRequest({
            url: '/customer/tmh/limit/searchlimitbypage',
            method: 'post',
            data: data,
        })
    },
    addLimit: function (data) {
        return tmhRequest({
            url: '/customer/tmh/limit/addlimit',
            method: 'post',
            data: data,
        })
    },
    editLimit: function (data) {
        return tmhRequest({
            url: '/customer/tmh/limit/editlimit',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/customer/customership.js